import React, { useState } from "react";
import { Container, Row, Col, Form, Button } from "react-bootstrap";
import "./index.scss";
import loginImage from "../../../assets/images/login.png"; // ✅ renommé
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { login } from "../../../services/auth";
// ✅ import correct de ton service login

const Login = () => {
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    email: "",
    password: "",
  });

  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    if (!formData.email || !formData.password) {
      toast.error("L'email et le mot de passe sont requis !");
      setLoading(false);
      return;
    }

    try {
      const res = await login(formData.email, formData.password);

      if (res.success) {
        navigate("/verify-code");
      } else {
        toast.error(res.msg || "Identifiants incorrects");
      }
    } catch (error) {
      toast.error("Erreur serveur. Veuillez réessayer plus tard.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container fluid className="login-page">
      <Row className="vh-100">
        {/* Partie gauche - Formulaire */}
        <Col
          md={6}
          className="d-flex align-items-center justify-content-center">
          <div className="login-box">
            <a href="/" className="back-link">
              ← Retour au tableau de bord
            </a>

            <h2 className="title">Connexion</h2>
            <p className="subtitle">
              Entrez votre email et votre mot de passe pour vous connecter !
            </p>

            <Form onSubmit={handleSubmit}>
              <Form.Group className="mb-3" controlId="formEmail">
                <Form.Label>
                  Email<span className="text-danger">*</span>
                </Form.Label>
                <Form.Control
                  type="email"
                  placeholder="exemple@gmail.com"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  autoComplete="email"
                />
              </Form.Group>

              <Form.Group className="mb-3" controlId="formPassword">
                <Form.Label>
                  Mot de passe<span className="text-danger">*</span>
                </Form.Label>
                <div className="password-input">
                  <Form.Control
                    type={showPassword ? "text" : "password"}
                    placeholder="Entrez votre mot de passe"
                    name="password"
                    value={formData.password}
                    onChange={handleChange}
                    autoComplete="current-password"
                  />
                  <span
                    className="toggle-password"
                    onClick={() => setShowPassword(!showPassword)}>
                    {showPassword ? "🙈" : "👁"}
                  </span>
                </div>
              </Form.Group>

              <div className="d-flex justify-content-between align-items-center mb-3">
                {/* <Form.Check type="checkbox" label="Rester connecté" /> */}
                <a href="/forgot-password" className="forgot-link">
                  Mot de passe oublié ?
                </a>
              </div>

              <Button
                type="submit"
                className="w-100 btn-signin"
                disabled={loading}>
                {loading ? "Connexion en cours..." : "Se connecter"}
              </Button>
            </Form>
          </div>
        </Col>

        {/* Partie droite - Illustration */}
        <Col
          md={6}
          className="d-none d-md-flex align-items-center justify-content-center right-side">
          <div className="text-center">
            <img
              src={loginImage}
              alt="Illustration de connexion"
              className="login-illustration img-fluid"
            />
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default Login;
